"use client";

import { Accordion, AccordionDetails, AccordionSummary, Box, colors, Typography, useTheme } from "@mui/material";
import { ChevronDown } from "lucide-react";
import PlpSectionHeading from "../../products/(plp)/components/PlpSectionHeading";
import { PLPSpecialBrand } from "../../products/(plp)/types";

export default function BrandAbout({ brand }: { brand: PLPSpecialBrand }) {
    const theme = useTheme();
    const entries = brand.about ?? [];
    if (!entries.length) return null;

    return (
        <Box component="section" sx={{ bgcolor: colors.grey[50], width: 1 }}>
            <Box sx={{
                maxWidth: 1400,
                marginX: "auto",
                py: 4,
                [theme.breakpoints.down("lg2")]: {
                    px: 3,
                },
            }}>
                <PlpSectionHeading>درباره {brand.name}</PlpSectionHeading>

                {entries.map((entry, index) => (
                    <AboutItem key={`${index}-${entry.title}`} title={entry.title} content={entry.content} />
                ))}
            </Box>
        </Box>
    );
}

function AboutItem({ title, content }: { title: string; content: string }) {
    const theme = useTheme();

    return (
        <Accordion elevation={0} sx={{
            bgcolor: "transparent",
            "&::before": {
                opacity: "0 !important",
                height: 0,
            },
            margin: "0 !important",
            mb: 1,
            borderTop: "1px solid",
            borderColor: colors.grey[400],
            borderRadius: "0 !important",
        }}>
            <AccordionSummary expandIcon={<ChevronDown color={colors.grey[700]} />} sx={{
                borderRadius: 0,
                [theme.breakpoints.down("md")]: {
                    padding: 0,
                },
            }}>
                {/* MuiAccordion already wraps the summary in its own h3, so this stays a
                    plain paragraph and does not nest a second heading inside it. */}
                <Typography sx={{
                    fontWeight: 500,
                    color: colors.grey[900],
                    fontSize: 16,
                    [theme.breakpoints.down("md")]: {
                        fontSize: 13,
                    },
                }}>
                    {title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{
                [theme.breakpoints.down("md")]: {
                    padding: 0,
                },
            }}>
                <Typography sx={{
                    fontSize: 14,
                    color: colors.grey[800],
                    textAlign: "justify",
                    lineHeight: "28px",
                    // Editors write these as plain paragraphs, so their line breaks are kept.
                    whiteSpace: "pre-line",
                    pb: 1,
                    [theme.breakpoints.down("md")]: {
                        fontSize: 12,
                        lineHeight: "23px",
                    },
                }}>
                    {content}
                </Typography>
            </AccordionDetails>
        </Accordion>
    );
}
